import { requestBuilder } from '../../../http/RequestBuilder';
import type { Card, ReissueCardBody } from '../../types/Card';

const useReissueCard = requestBuilder.mutation<Card, ReissueCardBody>({
    endpoint: '/api/card/reissue',
    method: 'POST',
});

export default useReissueCard;
